import { render } from "./LoginModal.vue?vue&type=template&id=45773fcc"
import script from "./LoginModal.vue?vue&type=script&lang=js"
export * from "./LoginModal.vue?vue&type=script&lang=js"

import "./LoginModal.vue?vue&type=style&index=0&id=45773fcc&lang=scss"
script.render = render

export default script